import { render, staticRenderFns } from "./email_login.vue?vue&type=template&id=511f4d48"
import script from "./email_login.vue?vue&type=script&lang=js"
export * from "./email_login.vue?vue&type=script&lang=js"
import style0 from "./email_login.vue?vue&type=style&index=0&id=511f4d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports